skrilla.filter('dollarOrSkrilla', function() {
    return function(input, currency, showDenomination) {
        if (input === undefined) {
            return '' ;
        }
        input = parseInt(input);
        if(showDenomination === null || showDenomination === undefined){
            showDenomination = true;
        }
        var isCrypto = false;
        switch (currency){
            case "SKR":
                input = divide(input, 1000000);
                isCrypto = true;
                break;
            case "ETH":
                input = divide(input, 1000000000);
                isCrypto = true;
                break;
            case "BTC":
                input = divide(input, 100000000);
                isCrypto = true;
                break;
            default:
                input = divide(input, 100);
                break;
        }
        return format(input, currency, showDenomination, isCrypto);
    };

    function divide(input, amount){
        return new BigNumber(input).dividedBy(amount).toNumber().toFixed(2);
    }

    function format(input, currency, showDenomination, isCrypto){
        if(showDenomination === true){
            if(isCrypto){
                return input + " " + currency;
            }
            else{
                const sign = input < 0 ? "-" : ""
                const abs = Math.abs(input)
                return sign + (currency === "EUR" ? "€" : "$") + (Number(abs).toFixed(2));
            }
        }
        else{
            return input;
        }
    }
})
